import {
    launcherGetProfiles,
    launcherSaveSettings,
    launcherProcessStatus,
} from '../launcherBackend/launcher-command'
import { constants as constantsBackend, selectors as backendSelectors } from '../features/Backend'
import { constants as usersConstants, selectors as usersSelectors } from '../features/Users'

function getProcessStatuses(state) {
    try {
        const serverId = backendSelectors.getActiveServerId(state)
        const userIds = usersSelectors.getActiveLoggedInUserIds(state)
        userIds.forEach((userId) => {
            launcherProcessStatus(serverId, userId)
        })
    } catch (error) {
        console.info(`Encountered error while running getProcessStatuses: ${error.message}`)
    }
}

const LauncherCommandMiddleware = store => next => (action) => {
    switch (action.type) {
        case usersConstants.USER_ADDED: {
            const result = next(action)
            launcherProcessStatus(action.payload.serverId, action.payload.userId)
            return result
        }
        case usersConstants.USERS_ADDED: {
            const result = next(action)
            getProcessStatuses(store.getState())
            return result
        }
        case constantsBackend.ACTIVE_SERVER_CHANGED: {
            const result = next(action)
            launcherGetProfiles(action.payload)
            getProcessStatuses(store.getState())
            return result
        }
        case constantsBackend.SETTINGS_CHANGED: {
            const result = next(action)
            launcherSaveSettings(action.payload)
            return result
        }

        default:
            return next(action)
    }
}

export default LauncherCommandMiddleware



// WEBPACK FOOTER //
// ./src/middlewares/LauncherCommandMiddleware.js